import * as Yup from "yup";
import { BaseUserSchema } from "./BaseUserSchema";

export const UpdateUserSchema = BaseUserSchema.shape({
    is_active: Yup.boolean(),
});
